/**
 * @generated SignedSource<<f2e09da09831d9810093b5dbbca0b271>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphBranch_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly entity: {
    readonly container?: {
      readonly name?: string | null | undefined;
    } | null | undefined;
    readonly name?: string | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null | undefined;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null | undefined;
    readonly lastModifiedDate: string | null | undefined;
    readonly providerId: string | null | undefined;
    readonly subtype: string | null | undefined;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null | undefined;
  readonly permissionLevel: string | null | undefined;
  readonly url: string;
  readonly " $fragmentType": "searchGraphBranch_AtlassianSearchPage";
};
export type searchGraphBranch_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphBranch_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphBranch_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v2 = {
  "kind": "ScalarField",
  "name": "url"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphBranch_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "name": "permissionLevel"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v3/*: any*/),
            {
              "kind": "LinkedField",
              "name": "container",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v3/*: any*/)
                  ],
                  "type": "ExternalRepository"
                }
              ]
            }
          ],
          "type": "ExternalBranch"
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "title"
        },
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "18a24dc86d2787d5d678dbcfc92fb480";

export default node;
